import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategorySortPipe } from './category-sort.pipe';

@NgModule({
  declarations: [CategorySortPipe],
  imports: [CommonModule],
  exports: [CategorySortPipe]
})
export class CategorySortPipeModule {}
